/* AUTO-GENERATED by frontend/scripts/generate-build-id.js
 * DO NOT EDIT BY HAND. Re-runs on every `yarn start` and `yarn build`.
 * Imported by frontend/src/lib/api.js. */
export const BUILD_ID = "gully-web-20261011-oauth-return-fallback-v1";
export const BUILD_AT = "2026-10-11T17:07:58.132Z";
